import { CSSObject } from '@emotion/react'
import { sharedStyles } from '../sharedStyles'

const accountMeasurer: CSSObject = {
  ...(sharedStyles.accountMeasurer as CSSObject),
  insetInlineStart: 15,
}

const getInput = (isHeadline?: boolean): CSSObject => ({
  marginBlockEnd: isHeadline ? 0 : 5,
  marginBlockStart: 0,
  marginInlineEnd: 10,
  marginInlineStart: 10,
})

const adInput: CSSObject = {
  ...getInput(),
  marginBlockStart: '-8px',
}

const styles = {
  accountMeasurer,
  getInput,
  adInput,
}

export { styles }
